import React from "react";
import { AccountInfoViewModel, IAccountInfoViewModel } from "Services/API/API";

interface IAccountContextModel extends IAccountInfoViewModel {
   refresh(): Promise<void>
}

const AccountContext = React.createContext<IAccountContextModel>({ ...new AccountInfoViewModel(), async refresh() { /* empty */ } });

export default AccountContext;